// extracted by mini-css-extract-plugin
module.exports = {"fullScreenLoaderWrapper":"fullScreenLoader_fullScreenLoaderWrapper__2Slu-"};